import CONSTANTS from './constants'

export default {
  [CONSTANTS.LAST_ID_SEEN]: undefined,
  [CONSTANTS.MESSAGE_PREVIEW_DATA]: undefined,
}
